import { useTranslation } from 'react-i18next';

import type { PresenceState } from '@ordago/shared';

import styles from './FriendsPanel.module.css';

export interface PresenceDotProps {
  state: PresenceState;
}

/**
 * The one thing a friend row says about somebody's whereabouts: what they are
 * doing, never where. Colour alone would fail anyone who cannot separate the
 * greens, so the state is also the accessible name and the tooltip.
 */
export function PresenceDot({ state }: PresenceDotProps) {
  const { t } = useTranslation('social');
  const label = t(`presence.${state}`);

  return (
    <span
      className={styles.dot}
      data-state={state}
      data-testid={`presence-${state}`}
      role="img"
      aria-label={label}
      title={label}
    />
  );
}
